import moment from "moment";
import React from "react";

const imageSizes = [
  [{ w: "100%", h: "100%" }],
  [
    { w: "100%", h: "50%" },
    { w: "100%", h: "50%" },
  ],
  [
    { w: "100%", h: "50%" },
    { w: "50%", h: "50%" },
    { w: "50%", h: "50%" },
  ],
  [
    { w: "50%", h: "50%" },
    { w: "50%", h: "50%" },
    { w: "50%", h: "50%" },
    { w: "50%", h: "50%" },
  ],
  [
    { w: "100%", h: "34%" },
    { w: "50%", h: "33%" },
    { w: "50%", h: "33%" },
    { w: "50%", h: "33%" },
    { w: "50%", h: "33%" },
  ],
  [
    { w: "50%", h: "34%" },
    { w: "50%", h: "34%" },
    { w: "50%", h: "33%" },
    { w: "50%", h: "33%" },
    { w: "50%", h: "33%" },
    { w: "50%", h: "33%" },
  ],
  [
    { w: "50%", h: "34%" },
    { w: "50%", h: "34%" },
    { w: "50%", h: "33%" },
    { w: "50%", h: "33%" },
    { w: "33%", h: "33%" },
    { w: "34%", h: "33%" },
    { w: "33%", h: "33%" },
  ],
  [
    { w: "50%", h: "34%" },
    { w: "50%", h: "34%" },
    { w: "33%", h: "33%" },
    { w: "34%", h: "33%" },
    { w: "33%", h: "33%" },
    { w: "33%", h: "33%" },
    { w: "34%", h: "33%" },
    { w: "33%", h: "33%" },
  ],
  [
    { w: "33%", h: "34%" },
    { w: "34%", h: "34%" },
    { w: "33%", h: "34%" },
    { w: "33%", h: "33%" },
    { w: "34%", h: "33%" },
    { w: "33%", h: "33%" },
    { w: "33%", h: "33%" },
    { w: "34%", h: "33%" },
    { w: "33%", h: "33%" },
  ],
];

export default function ListPreview({ list, onClick }) {
  const numItems =
    list.extraIngredients.length +
    list.selected.reduce(
      (partialSum, a) => partialSum + a.ingredients.filter((i) => !i).length,
      0
    );
  const images = list.selected
    .map((r) => r.recipe.image)
    .filter((_, i) => i < 9);
  return (
    <div
      style={{
        width: "200px",
        height: "250px",
        margin: "10px",
        borderRadius: "10px",
        position: "relative",
        border: "1px solid #aaa",
      }}
    >
      <div
        style={{
          backgroundColor: "#ddd",
          width: "100%",
          height: "100%",
          display: "flex",
          flexWrap: "wrap",
          borderRadius: "10px",
          overflow: "hidden",
        }}
      >
        {images.map((img, i) => (
          <img
            src={img}
            style={{
              objectFit: "cover",
              width: imageSizes[images.length - 1][i]["w"],
              height: imageSizes[images.length - 1][i]["h"],
              padding: 0,
              margin: 0,
            }}
          />
        ))}
      </div>
      <div
        style={{
          position: "absolute",
          top: 0,
          //   backgroundColor: "#fffc",
          background:
            "linear-gradient(180deg, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.8) 39%, rgba(255,255,255,0) 100%)",
          width: "100%",
          height: "100%",
          borderRadius: "10px",
          cursor: "pointer",
        }}
        onClick={onClick}
      >
        <div
          style={{
            textAlign: "center",
            fontSize: "22px",
            paddingTop: "5px",
            paddingBottom: "2px",
          }}
        >
          {list.name}
        </div>
        <div style={{ textAlign: "center", paddingBottom: "5px" }}>
          {moment(list.date).calendar()}
        </div>
        <div
          style={{ textAlign: "center" }}
        >{`${list.selected.length} recipies`}</div>

        <div style={{ textAlign: "center" }}>{`${numItems} items`}</div>
      </div>
    </div>
  );
}
